export const sanitizeNodeName = (name) => {
    return name
        .replace(/["\[\]{}()]/g, "")
        .replace(/[:;]/g, " -")
        .replace(/[&<>]/g, "")
        .replace(/\s+/g, " ")
        .replace(/^\s+|\s+$/g, "")
        .substring(0, 30);
};
//# sourceMappingURL=mermaidUtils.js.map